// Cálculos compartidos para que Categorías, Dashboard, Simulador y Billuyo muestren los mismos números.

const num = (n) => Number(n || 0);

export function totalAbonadoPorCompromiso(abonos) {
  const r = {};
  abonos.forEach(a => { r[a.compromiso_id] = (r[a.compromiso_id] || 0) + num(a.monto); });
  return r;
}

// Suma de lo ahorrado por meta (a partir de abonos_meta; los retiros son montos negativos).
export function ahorradoPorMeta(abonosMeta) {
  const r = {};
  abonosMeta.forEach(a => { r[a.meta_id] = (r[a.meta_id] || 0) + num(a.monto); });
  return r;
}

// Cuánto de una meta está reservado en cada categoría ('' = sin categoría).
export function reservadoMetaPorBolsillo(abonosMeta, metaId) {
  const r = {};
  abonosMeta.filter(a => a.meta_id === metaId).forEach(a => {
    const k = a.bolsillo_id || '';
    r[k] = (r[k] || 0) + num(a.monto);
  });
  return r;
}

export function calcularFinanzas({ bolsillos = [], movimientos = [], compromisos = [], abonos = [], abonosMeta = [] }) {
  const saldo = {};
  movimientos.forEach(m => {
    saldo[m.bolsillo_id] = (saldo[m.bolsillo_id] || 0) + (m.tipo === 'ingreso' ? num(m.monto) : -num(m.monto));
  });

  const abonado = totalAbonadoPorCompromiso(abonos);
  const comprometido = {};
  compromisos.filter(c => c.estado === 'pendiente').forEach(c => {
    const pendiente = Math.max(0, num(c.monto_total) - (abonado[c.id] || 0));
    comprometido[c.bolsillo_id] = (comprometido[c.bolsillo_id] || 0) + pendiente;
  });

  const enMetas = {};
  let enMetasSinCategoria = 0;
  abonosMeta.forEach(a => {
    if (a.bolsillo_id) enMetas[a.bolsillo_id] = (enMetas[a.bolsillo_id] || 0) + num(a.monto);
    else enMetasSinCategoria += num(a.monto);
  });

  const porBolsillo = (id) => {
    const s = saldo[id] || 0;
    const c = comprometido[id] || 0;
    const e = enMetas[id] || 0;
    return { saldo: s, comprometido: c, enMetas: e, disponible: s - c - e };
  };

  // Las categorías "aparte" (ej. el ahorro en efectivo) no se suman a lo que se puede gastar:
  // tienen su saldo, pero quedan fuera del saldo total, lo comprometido y el disponible real.
  const delDia = bolsillos.filter(b => !b.aparte);
  const totalSaldo = delDia.reduce((s, b) => s + porBolsillo(b.id).saldo, 0);
  const totalComprometido = delDia.reduce((s, b) => s + porBolsillo(b.id).comprometido, 0);
  const totalEnMetas = delDia.reduce((s, b) => s + porBolsillo(b.id).enMetas, 0) + enMetasSinCategoria;

  return {
    porBolsillo,
    totalSaldo,
    totalComprometido,
    totalEnMetas,
    enMetasSinCategoria,
    totalDisponible: totalSaldo - totalComprometido - totalEnMetas,
    totalAparte: bolsillos.filter(b => b.aparte).reduce((s, b) => s + porBolsillo(b.id).saldo, 0),
    enRojo: delDia.filter(b => porBolsillo(b.id).disponible < 0),
  };
}

// --- Gastos fijos ---
const FACTOR_MENSUAL = { semanal: 52 / 12, quincenal: 2, mensual: 1, semestral: 1 / 6, anual: 1 / 12 };

export function equivalenteMensual(g) {
  return num(g.monto) * (FACTOR_MENSUAL[g.frecuencia] || 1);
}

const semestre = (mes) => (mes <= 6 ? 1 : 2);

// ¿El pago registrado (mes/año) cubre el período de la fecha?
// Anual: todo el año. Semestral: el mismo semestre. El resto: el mismo mes.
export function mismoPeriodoGastoFijo(g, mesPago, anoPago, fecha) {
  if (anoPago !== fecha.getFullYear()) return false;
  if (g.frecuencia === 'anual') return true;
  if (g.frecuencia === 'semestral') return semestre(mesPago) === semestre(fecha.getMonth() + 1);
  return mesPago === fecha.getMonth() + 1;
}

export function gastoFijoPagado(g, fecha = new Date()) {
  if (!g.pagado) return false;
  return mismoPeriodoGastoFijo(g, g.mes_pago, g.ano_pago, fecha);
}
